import React from "react";
import { Button as BUTTON } from "antd";

const Button = ({
  icon,
  htmlType,
  title,
  color,
  border,
  onClick,
  disabled,
  className = "w-31 xl:w-40",
  loading,
}) => {
  return (
    <>
      <BUTTON
        htmlType={htmlType}
        className={className}
        disabled={disabled}
        loading={loading}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: `${color}`,
          padding: "8px 16px 8px",
          height: "54px",
          borderRadius: "12px",
          border: border ? `2px solid ${border}` : "",
          color: border ? { border } : "white",
        }}
        onClick={onClick}
      >
        {icon ? <img src={icon} className="mr-0.4" alt="asdas" /> : ""}
        {title}
      </BUTTON>
    </>
  );
};

export default Button;
